export const DAY_MS = 24 * 60 * 60 * 1000

export const JOI_QUICKSTART_LINK = 'https://www.joi.events/quickstart/getting-started-with-joi?utm_campaign=Quickstart%20guide%20from%20app&utm_source=Joi%20app'
export const AUS_SYD_TIMEZONE = "Australia/Sydney"
export const MY_CREATED_TASKS = 'Tasks created by me'
export const MY_CREATED_ASSETS = 'Assets created by me'
export const FLAGGED_ASSETS = 'Flagged Assets'
export const FLAGGED_TASKS = 'Flagged Tasks'
export const MY_RESPONSIBLE_TASKS = 'Tasks I am responsible for'
export const MY_RESPONSIBLE_ASSETS = 'Assets I am responsible for'
export const MY_EVENTS = 'My events'
export const MAX_ENTITY_STARS = 5
export const INTERNAL_PUBLISH_VERSION = 1.0
export const DEFAULT_BRANDING_TEXT_SIZE = 14

export enum MonthAbbr { JAN, FEB, MAR, APR, MAY, JUN, JUL, AUG, SEP, OCT, NOV, DEC }
export enum MonthFull { January, February, March, April, May, June, July, August, September, October, November, December }
export enum DayFull { Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday }
export enum DayFullAbbr { Sun, Mon, Tue, Wed, Thu, Fri, Sat }
export const CalendarDays = Object.values(DayFull).filter(d => typeof d === 'string') // this can be used in *ngFor in templates, unlike the enum above
export const TASK_SAVE_DEBOUNCE_AND_SKIP_DUPLICATE_MS = 500 // Might need to test the delay between loading of subscriptions when there are lots of tasks
export enum DayAbbr { Sun, Mon, Tue, Wed, Thu, Fri, Sat }
export const N_TICKS = 25

export type EMAIL = string
export type USER_ID = string
